contr<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      icon="mdi-file-document-edit-outline"
      :breadcrumbs="breadcrumbs"
    ></vuse-section-definition>
    <v-container fluid>
        <v-row class="mx-1">
          <v-col cols="8" class="content_category rounded-lg">
            <v-row class="mx-3">
              <v-col cols="12">
                  <v-select
                    background-color="#EDF2F7"
                    filled
                    :items="items"
                    v-model="news.type"
                    label="Chọn loại"
                    item-text="text"
                    item-value="value"
                  ></v-select>
              </v-col>
              <v-col cols="12">
                <v-checkbox
                    v-model="news.is_promotional"
                    label="Khuyến mại"
                    color="primary"
                    value="1"
                ></v-checkbox>
              </v-col>
              <v-col cols="12">
                  <v-text-field
                    background-color="#EDF2F7"
                    filled
                    label="Tên bài viết"
                    placeholder="Nhập tên bài viết"
                    v-model="news.name"
                    :rules="[checkChar]"
                    counter
                  ></v-text-field>
              </v-col>
              <v-col cols="12">
                  <v-text-field
                    background-color="#EDF2F7"
                    filled
                    label="Slug"
                    placeholder="Nhập Slug"
                    @blur="triggerSeo"
                    v-model="news.slug"
                  ></v-text-field>
              </v-col>
            <v-col cols="12">
                  <v-textarea
                   class="content-textarea"
                    background-color="#EDF2F7"
                    filled
                    label="Mô tả"
                    placeholder="Nhập mô tả"
                    v-model="news.description"
                    :rules="[checkCharDescription]"
                    counter
                  ></v-textarea>

              </v-col>
              <v-col cols="12">
                <add-module @inputData="addModule">
                </add-module>

              </v-col>
              <v-col cols="12">
                <ck-content class="ck-news" :content="news.content" @getData="value => news.content = value"  @getSeo="triggerSeo"/>
              </v-col>
              <v-col cols="6">
                <v-row class="">
                  <v-col>
                    <h4>No-index</h4>
                    <div>
                      <v-switch
                          v-model="news.no_index"
                      ></v-switch>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                  <v-text-field
                    background-color="#EDF2F7"
                    filled
                      @blur="triggerSeo"
                    label="SEO Title"
                    placeholder="Nhập SEO Title"
                    v-model="news.meta_title"
                  ></v-text-field>
              </v-col>
              <v-col cols="12">
                  <v-textarea
                    class="content-textarea"
                    background-color="#EDF2F7"
                    filled
                      @blur="triggerSeo"
                    label="SEO Description"
                    placeholder="Nhập mô tả"
                    v-model="news.meta_description"
                  >
                  </v-textarea>
              </v-col>
              <v-col cols="12" v-if="news.type == 2">
                  <v-text-field
                    background-color="#EDF2F7"
                    filled
                    label="URL video"
                    placeholder="Nhập URL của video"
                    v-model="news.video_url"
                  ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="3" class="content_category rounded-lg ml-3 pa-0 ma-0">
            <div>
              <h4 class="mb-3 mt-3 ml-3">Category</h4>
              <v-divider></v-divider>
              <div
                class="overflow-y-auto pa-0 ma-0"
                id="scroll-target"
                style="max-height: 1020px"
              >
                <div
                  class="mx-3"
                  v-scroll.#scroll-target="onScroll"
                  style="height: 1020px"
                >
                  <v-radio-group v-model="news.category_id" column>
                      <div v-for="item in category" v-bind:key="item.id">
                        <v-row>
                          <v-col cols="10" class="d-flex align-center">
                            <v-checkbox
                              @change="checkedCategory(item.id)"
                              :label="item.name"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="2" class="d-flex align-end">
                            <v-radio :value="item.id"></v-radio>
                          </v-col>
                        </v-row>
                      </div>
                  </v-radio-group>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="8" class="content_category mt-3 rounded-lg">
            <v-col cols="6">
                <v-file-input
                  label="Ảnh tiêu đề"
                  placeholder="Tải ảnh lên"
                  prepend-icon="mdi-camera"
                  @change="fileSelected"
                ></v-file-input>
              <v-img  :src="src"></v-img>
              <v-text-field 
                  background-color="#EDF2F7"
                  filled
                  label="Alt ảnh đại diện"
                  v-model="news.alt_image"
                  placeholder="Nhập alt"
              ></v-text-field>
            </v-col>
          </v-col>
          <v-col cols="3" class="content_category rounded-lg ml-3 mt-3">
            <div class="mx-2">
              <h4 class="mb-2">Product tags</h4>
              <v-divider></v-divider>
              <div>
                  <v-autocomplete
                    v-model="list_tag_id"
                    :items="list_tags"
                    item-value="id"
                    item-text="name"
                    chips
                    label="Tags"
                    multiple
                    outlined
                  ></v-autocomplete>
              </div>
            </div>
          </v-col>
          <seo 
            @getKeywords="getKeywords"
            :trigger_seo="count_trigger_seo"
            :text_seo="text_seo"
            :meta_title="news.meta_title"
            :content="news.content"
            :slug="news.slug"
            :meta_description="news.meta_description"
          />
          <v-col cols="8" class="text-center">
            <v-btn @click="save()" color="primary" width="180"> Lưu </v-btn>
          </v-col>
        </v-row>
    </v-container>
  </div>
</template>
<script>
import {
  UPLOAD_NEWS_IMAGE,
  SAVE_NEWS,
  GET_LIST_CATEGORIES,
} from "@/store/modules/news";
import { GET_LIST_TAG } from "@/store/modules/tag";
import { mapGetters } from "vuex";
import CkContent from "@/components/ck-content"
import { replaceCkContent } from '@/utils/helpers'
import Seo from "@/components/seo"
import {
  // ValidationProvider,
  // ValidationObserver,
  // localize,
} from "vee-validate/dist/vee-validate.full";
import AddModule from "@/views/Pages/production/add_module"

export default {
  components: {
    // ValidationProvider,
    // ValidationObserver,
    CkContent,
    AddModule,
    Seo

  },
  data() {
    return {
      count_trigger_seo: 0,
      offsetTop: 0,
      text_seo: "",
      errors_ : 0,
      page: "Thêm bài viết",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý bài viết",
          disabled: true,
        },
        {
          text: "Thêm bài viết",
          disabled: true,
        },
      ],
      items: [
        {
          value: 1,
          text: "Bài viết",
        },
        {
          value: 2,
          text: "Video",
        },
      ],
      SEO: [],
      // image
      img: null,
      src: "",
      image: {},
      // tag
      list_tags: [],
      list_tag_id: [],
      // news
      news: {
        id: "",
        type: null,
        name: "",
        description: "",
        content: "",
        slug: "",
        meta_title: "",
        meta_keyword: "",
        meta_description: "",
        category_id: null,
        photo_url: "",
        video_url: "",
        category_ids: [],
        list_tag: [],
        is_promotional:0,
        alt_image: '',
        no_index:false
      },
    };
  },
  methods: {
    checkCharDescription(value){
      if(value.length <= 70 || value.length >= 160){
        return 'Mô tả bài viết khuyến nghị từ 70 - 160 kí tự';
      }
    },
    checkChar(value){
      if(value.length <= 60 || value.length >= 65){
        return 'Tiêu đề bài viết khuyến nghị từ 60 - 65 kí tự';
      }
    },
    onScroll (e) {
      this.offsetTop = e.target.scrollTop
    },
    addModule(val){
        let a = "#####" + JSON.stringify(val)+"#####"
        this.news.content = this.news.content + a ;
    },
    fileSelected(event) {
      if (!event) {
        this.src = "";
        this.news.photo_url = "";
      }
      this.image = event;
      this.src = URL.createObjectURL(this.image);
      if (this.image) {
        this.hasImage = !this.hasImage;
      }
      let formData = new FormData();
      formData.append("upload", this.image);
      formData.append("type", "posts");
      this.$store.dispatch(`${UPLOAD_NEWS_IMAGE}`, formData).then((data) => {
        this.news.photo_url = data.data.data[0].path;
      });
    },
    save() {
      const _this = this;
      //list tags
      this.list_tag_id.forEach((id) => {
        let tag = _this.list_tags.find((el) => el.id == id);
        _this.news.list_tag.push({
          id: tag.id,
          name: tag.name,
        });
      });
      let data_news = {
        name: this.news.name,
        type: this.news.type,
        content: replaceCkContent(this.news.content),
        slug: this.news.slug,
        description: this.news.description,
        meta_title: this.news.meta_title,
        meta_keyword: this.news.meta_keyword,
        meta_description: this.news.meta_description,
        category_id: this.news.category_id,
        video_url: this.news.video_url,
        photo_url: this.news.photo_url,
        list_tag: JSON.stringify(this.news.list_tag),
        category_ids: JSON.stringify(this.news.category_ids),
        is_promotional: this.news.is_promotional,
        alt_image: this.news.alt_image,
        no_index: this.news.no_index,
      };
      this.$store.dispatch(`${SAVE_NEWS}`, data_news).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          this.$router.push("/manage_news/manage_new");
        }
        else{
            alert(data.data.errors)
        }
      });
    },
    checkedCategory(id) {
      if (this.news.category_ids.indexOf(id) != -1) {
        this.news.category_ids = this.news.category_ids.filter((item) => {
          return item != id;
        });
      } else {
        this.news.category_ids.push(id);
      }
    },
    triggerSeo(){
      this.count_trigger_seo++;
    },
    getKeywords(keywords){
      console.log(keywords);
      this.meta_keyword = keywords
    }
  },
  computed: {
    ...mapGetters({
      category: "category",
      tags: "tags",
    }),
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_CATEGORIES}`);
    await this.$store.dispatch(`${GET_LIST_TAG}`);
  },
  watch: {
    tags(val) {
      if (val) {
        val.forEach((el) => {
          this.list_tags.push({
            id: el.id,
            name: el.name,
          });
        });
      }
    }
  },
};
</script>
<style lang="scss">
.content_category {
  background: #ffffff !important;
  .content-textarea .v-input__control {
    height: 165px !important;
  }
  .v-input--checkbox .v-input__control {
    height: 22px !important;
  }
  .content-textarea.v-textarea .v-input__control{
    display: grid;
  }
}
.ck-news .ck-editor__main .ck-content {
  height: 140px;
}
</style>